module.exports = __webpack_public_path__ + "img/facebook.c82342d1.png";